import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DocumentBackendInfo, DriverLicenseExtraction, UploadedDriverLicense, ViewedDriverLicense } from '../../../models/document.model';

export const driverLicenseActions = createActionGroup({
    source: 'DriverLicense',
    events: {
        // Presigned URL
        'Get Presigned Url': props<{ filename: string }>(),
        'Get Presigned Url Success': props<{ payload: string }>(),
        'Get Presigned Url Fail': emptyProps(),

        // Upload to S3
        'Upload S3': props<{ data: File; url: string }>(),
        'Upload S3 Success': emptyProps(),
        'Upload S3 Fail': emptyProps(),
        'Clear Upload S3': emptyProps(),

        'Clear Presigned Url': emptyProps(),

        // PDF: multipart upload diretto. Immagini: notifica backend dopo S3.
        'Upload Backend': props<{
            file_type: 'pdf' | 'img';
            timestamp: string;
            file?: File;
            customer_id?: number;
            data?: DocumentBackendInfo;
        }>(),
        'Upload Backend Success': props<{ payload: UploadedDriverLicense }>(),
        'Upload Backend Fail': emptyProps(),
        'Clear Upload Backend': emptyProps(),

        // Extraction
        'Extract': props<{ driver_license_id: number }>(),
        'Extract Success': emptyProps(),
        'Extract Fail': emptyProps(),

        // View / extraction info
        'Load Extraction Info': props<{ extracted_id: number }>(),
        'Load Extraction Info Success': props<{ payload: ViewedDriverLicense }>(),
        'Load Extraction Info Fail': emptyProps(),
        'Load View Success': props<{ payload: ViewedDriverLicense }>(),
        'Clear View': emptyProps(),

        // Edit extraction
        'Edit Extraction': props<{ extracted_id: number; data: DriverLicenseExtraction }>(),
        'Edit Extraction Success': props<{ payload: DriverLicenseExtraction }>(),

        // Download
        'Download': props<{ ids: number[] }>(),
        'Download Success': props<{ payload: string[] }>(),
        'Clear Download': emptyProps(),

        // Delete documento (elimina anche l'estrazione associata, cascata backend)
        'Delete Document': props<{ id: number }>(),
        'Delete Document Success': emptyProps(),
        'Delete Document Fail': emptyProps(),
        'Clear Delete Document': emptyProps(),

        // Delete estrazione
        'Delete Extraction': props<{ extracted_id: number }>(),
        'Delete Extraction Success': emptyProps(),
        'Delete Extraction Fail': emptyProps(),
        'Clear Delete Extraction': emptyProps(),

        // CSV estrazione
        'Get CSV': props<{ ids: number[] }>(),
        'Get CSV Success': props<{ payload: string }>(),
        'Clear CSV': emptyProps(),

        // Excel estrazione
        'Get Excel': props<{ ids: number[] }>(),
        'Get Excel Success': props<{ payload: Blob }>(),
        'Clear Excel': emptyProps(),
    },
});
